import { faX } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { PartnerOfficeLeadForm } from "@component/PartnerOffice/LeadForm/PartnerOfficeLeadForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FakeButton } from "@ui/components/FakeButton";
import { Button } from "bm-ui-kit";
import classNames from "classnames";
import React, { type ReactNode, type FC, useMemo } from "react";
import { Card } from "react-bootstrap";
import "./style.scss";

interface OfficeCardProps {
	className?: string;
	imgSrc: string;
	imgAlt?: string;
	title: ReactNode;
	address: ReactNode;
	openingHours: string;
	contactInfo: string;
	consultantId: string;
}

export const OfficeCard: FC<OfficeCardProps> = ({
	className,
	imgSrc,
	imgAlt,
	title,
	address,
	openingHours,
	contactInfo,
	consultantId,
}) => {
	const [active, setActive] = React.useState(false);

	const openingHoursBlock = useMemo(() => {
		if (!openingHours) {
			return null;
		}

		const openingHoursLines = openingHours.split("\n");

		return (
			<p>
				{openingHoursLines.map((line, index) => (
					<span key={index}>
						{line}
						{index < openingHoursLines.length - 1 && <br />}
					</span>
				))}
			</p>
		);
	}, [openingHours]);

	return (
		<div className="flip-card">
			<div className={classNames("flip-card-inner", { "flip-card-flipped": active })}>
				<Card className={classNames(className, "flip-card-front", "shadow", "h-100")}>
					{!!imgSrc && <Card.Img className="p-2" src={imgSrc} alt={imgAlt} />}
					<Card.Body className="p-4">
						<h3>{title}</h3>
						<p>{address}</p>
						<p>
							<strong className="text-primary">Előzetes bejelentkezés szükséges!</strong>
						</p>
						{openingHoursBlock}
						{!!contactInfo && <p className="mb-0">Kapcsolattartó: {contactInfo}</p>}
					</Card.Body>
					{!!consultantId && (
						<Card.Footer className="pb-4 px-4">
							<Button onClick={() => setActive(!active)}>Ingyenes Tanácsadás</Button>
						</Card.Footer>
					)}
				</Card>
				<div className="flip-card-back">
					<FakeButton className="btn-close" onClick={() => setActive(!active)}>
						<FontAwesomeIcon icon={faX} />
					</FakeButton>
					<PartnerOfficeLeadForm consultantId={consultantId} />
				</div>
			</div>
		</div>
	);
};
